import { parseQuery } from '@shared/utils/querystring'
import receiveCodeQQ from '@/postMessage/receiveCodeQQ'
import receiveCodeWechat from '@/postMessage/receiveCodeWechat'
import { jsonParse } from '@/utils/shared'

let isBindEvent = false

const DOMAIN_REG = {
  IJINSHAN: /ijinshan.com/,
  DAOHANG: /duba.com/,
  WP: /zhhainiao.com/,
  CHEETAHFUN: /cheetahfun.com/,
}

const getParentPostmessageDomain = function () {
  try {
    const url = parseQuery(window.location.search).postmessage_domain
    if (!url) return ''

    return window.decodeURIComponent(url)
  } catch (e) {
    console.error(e)
  }
  return ''
}

const validDomain = (origin) => {
  for (const key in DOMAIN_REG) {
    if (DOMAIN_REG[key].test(origin)) {
      return true
    }
  }
  return false
}

export const bindEventPostMessage = () => {
  if (isBindEvent) return

  // 兼容通知，负责消息分发
  window.addEventListener('message', (ev) => {
    const origin = ev.origin
    const dataStr = ev.data

    if (!dataStr) return

    let data = jsonParse(dataStr)
    console.log(data, ev)
    if (!validDomain(origin)) {
      return
    }

    const dataModel = {
      search: {
        type: '',
        code: '',
      },
      hash: {
        access_token: '', // QQ的code是从hash中返回
      },
    }
    data = Object.assign({}, dataModel, data)

    // type:消息类型
    const { type, code } = data.search

    if (type === 'wechat') {
      receiveCodeWechat(code)
    } else if (type === 'qq') {
      receiveCodeQQ(data.hash.access_token)
    }
  }, false)

  isBindEvent = true
}

const postMessageToParent = (data) => {
  if (!data) return

  const domain = getParentPostmessageDomain()
  if (!domain) return

  try {
    window.parent.postMessage(JSON.stringify(data), domain)
  } catch (e) {
    console.error(e)
  }
}

// 退敌-用户信息
export const publishUserInfo = function (data = '') {
  postMessageToParent({ type: 'user_login', data })
}

// 通知-页面已经加载到
export const publishPageLoaded = () => {
  postMessageToParent({ type: 'page_loaded' })
}

// 通过-页面关闭
export const publishPageClose = () => {
  // console.log('通过-页面关闭')
  postMessageToParent({ type: 'page_close' })
}

// 上报通知
export const publishReport = (reportData = {}) => {
  postMessageToParent({ type: 'report', data: reportData })
}
